<template>
  <div class="sales_reservation">
    <img class="background_image" src="/static/salesReservation/backGroundA.png"></img>
    <div class="overlay"></div>
    <div class="content">
      <h1 class="insunet_fc">INSUNET FC</h1>
      <p class="description">
        항상 고객의 입장에서 생각하고,<br />
        합리적인 선택을 하도록 돕는 보험대리점
      </p>
      <button class="consultation_button" @click="handleClick">상담 신청</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesReservationA',
  props: {
    refin: {
      type: String,
      default: ''
    },
    sorce: {
      type: String,
      default: ''
    }
  },
  mounted() {
    console.log('refin:', this.refin);
    console.log('sorce:', this.sorce);
  },
  methods: {
    handleClick() {
      console.log('상담 신청 버튼이 클릭되었습니다.');
      console.log('refin:', this.refin);
      console.log('sorce:', this.sorce);

      this.$router.push({
        path: '/sales/reservationd',
        query: {
          refin: this.refin,
          sorce: this.sorce
        }
      });
    }
  }
}
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css");

body, .sales_reservation, .insunet_fc, .description, .consultation_button {
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
}

.sales_reservation {
  width: 100vw;
  height: calc(100vh - 86px); /* 여기를 수정 */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.background_image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 2px);
  height: calc(100% + 2px); 
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 16, 39, 0.5);
}

.content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  width: 100%;
  height: 100%;
}

.insunet_fc {
  color: #ffffff;
  font-size: clamp(24px, 6vw, 72px);
  letter-spacing: 0.05em;
  font-weight: 800; /* ExtraBold */
  margin-bottom: 2vh;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.description {
  color: #ffffff;
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.5;
  letter-spacing: 0.03em;
  font-weight: 500; 
  margin-bottom: 3vh;
  max-width: 80%;
  position: absolute;
  top: calc(55% + 10px); /* 여기를 수정 */
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.consultation_button {
  color: #ffffff;
  font-size: clamp(18px, 2vw, 24px);
  font-weight: 700; /* Bold */
  background: none;
  border: 2px solid #ffffff;
  border-radius: 50px;
  padding: 12px 50px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  position: absolute;
  bottom: calc(15% - 43px); /* 여기를 수정 */
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  Width: 300px;
}

.consultation_button:hover {
  background-color: #ffffff;
  color: #000000;
}

</style>